<ng-container *ngIf="column">
  <mat-form-field appearance="outline" class="aval-editinput miq-form-input">
    <input
      autocomplete="off"
      class="mainInput"
      #input
      matInput
      miqOnlyNumbers
      [allowedKeyCodes]="allowedKeyCodes"
      [restrictedKeyCodes]="restrictedKeyCodes"
      [formControl]="fc"
      [maxLength]="maxAllowedChars"
    />
  </mat-form-field>
</ng-container>
